import Token from '@/utils/Token';

export default {
    modulos() {
        return axios.get('/api/exportacao-consolidada/modulos', Token.getHeader());
    },
    download(params = '') {
        if (params) {
            params = `?${params}`;
        }
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/exportacao-consolidada/download${params}`, headers);
    },
};
